<template>
    <div class="container-fluid">
        <br>
        <router-link to="/messages" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <button type="button" :disabled="loading" @click="saveData" class="btn btn-lg btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item">
                            <a class="nav-link active" href="#tabFormulario" aria-controls="tabFormulario" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-send"></i>
                                Enviar Mensagem
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane active" id="tabFormulario">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <required /> <label>Número</label>
                                        <input class="form-control" :class="{'is-invalid': errors.has('numero')}" name="Ip"
                                            v-mask="['(##)####-####', '(##)#####-####']"
                                            v-validate="{required: true, max:60}" :placeholder="'Insira o numero'"
                                            v-model="message.number">
                                        <div class="invalid-feedback help-block error">{{errors.first('numero')}}
                                        </div>
                                        <small>O número de telefone do destinatário no formato: [DDD] [Número do telefone]. Exemplo: (62) 8231-xxxxx.</small>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Mensagem</label><br />
                                        <textarea class="form-control" :class="{'is-invalid': errors.has('text')}"
                                            name="text" v-validate="{required: true, max:200}"
                                            :placeholder="'Insira a mensagem'" v-model="message.text">
                                        </textarea>
                                        <div class="invalid-feedback help-block error">{{errors.first('text')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Anexo</label><br />
                                        <input type="file" @input="appendFile" class="form-control" :class="{'is-invalid': errors.has('file')}"
                                            name="file" v-validate="{required: false}"
                                            :placeholder="'Insira arquivo de anexo (imagem, video ou PDF)'">                                        
                                        <div class="invalid-feedback help-block error">{{errors.first('file')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                message: {                  
                    number: null,
                    text: null,
                    file: null,
                    type: 'Text',
                    url_file: null,
                },
                loading: false,
            };
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        methods: {
            saveData() {
                this.loading = true;
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.$route.name === 'messageEdit' ?
                            this.updateData('updateMessage', this.message, '/messages') :
                            this.storeData('storeMessage', this.message);
                    } else this.loading = false;
                });
            },
            updateData() {
                this.$store.dispatch('updateMessage', this.message).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        this.$router.push('/messages');
                    }
                });
            },
            appendFile(event) {
                this.message.file = event.target.files[0];
            },
            storeData() {
                let formData = new FormData();
                formData.append('number', this.message.number);
                formData.append('text', this.message.text);
                formData.append('file', this.message.file);
                formData.append('type', this.message.type);
                formData.append('url_file', this.message.url_file);
                this.$store.dispatch('storeMessage', formData).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                    }
                });
            },
        },

    };
</script>